import { OptionalTruthyStringSchema } from 'notable-common';
import { z } from 'zod';
import { FlowAsynchronousExportJobKind, FlowAsynchronousExportJobNullableStringSchema, FlowAsynchronousExportJobOrderParamsSchema, FlowAsynchronousExportJobPayorParamsSchema, FlowAsynchronousExportJobRequiredStringSchema, } from './common.js';
const AuthorizationStatusSchema = z.object({
    note: FlowAsynchronousExportJobNullableStringSchema,
    authorizationRequired: FlowAsynchronousExportJobNullableStringSchema.default('false'),
    status: FlowAsynchronousExportJobRequiredStringSchema,
    authorizationNumber: FlowAsynchronousExportJobNullableStringSchema,
    patientType: FlowAsynchronousExportJobRequiredStringSchema,
    requestedDate: FlowAsynchronousExportJobNullableStringSchema,
    obtainedDate: FlowAsynchronousExportJobNullableStringSchema,
    effectiveDate: FlowAsynchronousExportJobNullableStringSchema,
    expirationDate: FlowAsynchronousExportJobNullableStringSchema,
    trackingNumber: FlowAsynchronousExportJobNullableStringSchema,
    rejectedComment: FlowAsynchronousExportJobNullableStringSchema,
    reason: FlowAsynchronousExportJobRequiredStringSchema,
    verificationGsPath: FlowAsynchronousExportJobNullableStringSchema,
});
export const FlowExportAuthorizationStatusPayloadSchema = z.object({
    jobKind: z.literal(FlowAsynchronousExportJobKind.ExportAuthorizationStatus),
    payload: FlowAsynchronousExportJobOrderParamsSchema.extend(FlowAsynchronousExportJobPayorParamsSchema.shape).extend({
        authorizationStatus: AuthorizationStatusSchema,
        authorizationSubmissions: OptionalTruthyStringSchema.default('[]'),
        cptCode: FlowAsynchronousExportJobNullableStringSchema,
        rawProcedures: FlowAsynchronousExportJobNullableStringSchema,
        referredToDepartment: FlowAsynchronousExportJobNullableStringSchema,
        referredByDepartment: FlowAsynchronousExportJobNullableStringSchema,
    }),
});
// V2
const AuthorizationStatusSchemaV2 = z.object({
    note: FlowAsynchronousExportJobNullableStringSchema,
    authorizationRequired: FlowAsynchronousExportJobRequiredStringSchema,
    status: FlowAsynchronousExportJobRequiredStringSchema,
    authorizationNumber: FlowAsynchronousExportJobNullableStringSchema,
    patientType: FlowAsynchronousExportJobRequiredStringSchema,
    requestedDate: FlowAsynchronousExportJobNullableStringSchema,
    obtainedDate: FlowAsynchronousExportJobNullableStringSchema,
    effectiveDate: FlowAsynchronousExportJobNullableStringSchema,
    expirationDate: FlowAsynchronousExportJobNullableStringSchema,
    trackingNumber: FlowAsynchronousExportJobNullableStringSchema,
    rejectedComment: FlowAsynchronousExportJobNullableStringSchema,
    reason: FlowAsynchronousExportJobRequiredStringSchema,
    verificationGsPath: FlowAsynchronousExportJobNullableStringSchema,
});
export const FlowExportAuthorizationStatusPayloadSchemaV2 = z.object({
    jobKind: z.literal(FlowAsynchronousExportJobKind.ExportAuthorizationStatusV2),
    payload: FlowAsynchronousExportJobOrderParamsSchema.extend(FlowAsynchronousExportJobPayorParamsSchema.shape).extend({
        authorizationStatus: AuthorizationStatusSchemaV2,
        authorizationSubmissions: OptionalTruthyStringSchema,
        cptCode: FlowAsynchronousExportJobNullableStringSchema,
        rawProcedures: FlowAsynchronousExportJobNullableStringSchema,
        referredToDepartment: FlowAsynchronousExportJobNullableStringSchema,
        referredByDepartment: FlowAsynchronousExportJobNullableStringSchema,
    }),
});
//# sourceMappingURL=exportAuthorizationStatus.js.map